<div class="card card-danger">
  <div class="card-header">
    <div class="float-left"><h5> Clients </h5></div>
    <div class="float-right">
      <div class="btn-group" role="group" aria-label="Basic example">
        <button (click)="showFind()" type="button" class="btn btn-sm btn-outline-info"><i class="fa fa-search" aria-hidden="true"></i> Find</button>
        <button (click)="showNew()" type="button" class="btn btn-sm btn-outline-success"><i class="fa fa-plus" aria-hidden="true"></i> Add new </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="row" >
      <div class="col">
        <div *ngIf="mode==formModes.Find">
          <div class="row" style="margin-left: 0px;">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="Name" class="col-sm-3 col-form-label" style="position: relative; top: 6px;">Name</label>
                <div class="col-sm-9" style="margin-left: -64px; height: 0px;">
                  <!-- <input [(ngModel)]="clientName" maxlength="50" class="form-control form-control-sm" #name="ngModel" type="text" id="Name" name="Name"/> -->
                  <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input matInput [(ngModel)]="clientName" maxlength="50" #name="ngModel" type="text" id="Name" name="Name" />
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12" style="position: relative; top: 16px;">
              <div class="text-center m-3">
                <button type="button" (click)="onSubmit()" class="btn btn-sm btn-info mx-1"><i class="fa fa-search" aria-hidden="true"></i> Search </button>
                <button type="button" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
              </div>
              <br />
            </div>
          </div>
        </div>

        <div *ngIf="mode==formModes.New || mode==formModes.Edit" style="margin-left: 80px;">
          <form #f="ngForm" (ngSubmit)="onSubmit(f)">
            <div class="row" style="margin-right: -41px">
              <div class="col-sm-6">

                <div class="form-group row">
                  <label for="Name" class="col-sm-3 col-form-label">Name</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>Client master name</mat-label>
                      <input matInput [(ngModel)]="model.name" required maxlength="50" #name="ngModel" type="text" id="Name" name="Name">
                    </mat-form-field>
                    <div *ngIf="name.invalid && (name.dirty && name.touched)" class="text-danger small">
                      <div *ngIf="name.errors.required">
                        Name is required.
                      </div>
                      <div *ngIf="name.errors.maxlength">
                        Name must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="BillingID" class="col-sm-3 col-form-label">Billing ID</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>Billing Id</mat-label>
                      <input matInput [(ngModel)]="model.billingID" required maxlength="50" #billingID="ngModel" type="text" id="BillingID" name="BillingID">
                    </mat-form-field>
                    <div *ngIf="billingID.invalid && (billingID.dirty && billingID.touched)" class="text-danger small">
                      <div *ngIf="billingID.errors.required">
                        BillingID is required.
                      </div>
                      <div *ngIf="billingID.errors.maxlength">
                        Egine must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="BillingContactID" class="col-sm-3 col-form-label">Billing Contact ID</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>Billing Contact ID</mat-label>
                      <input matInput [(ngModel)]="model.billingContactID" required maxlength="50" #billingContactID="ngModel" type="text" id="BillingContactID" name="BillingContactID">
                    </mat-form-field>
                    <div *ngIf="billingContactID.invalid && (billingContactID.dirty && billingContactID.touched)" class="text-danger small">
                      <div *ngIf="billingContactID.errors.required">
                        BillingContactID is required.
                      </div>
                      <div *ngIf="billingContactID.errors.maxlength">
                        BillingContactID must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="NetTermDays" class="col-sm-3 col-form-label">Net Term Days</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>Net Term Days</mat-label>
                      <input matInput [(ngModel)]="model.netTerms" maxlength="50" #netTerms="ngModel" value="0" type="number" pattern="[0-9]*" inputmode="numeric" min="0" id="NetTerms" name="NetTerms">
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="col-sm-6">

                <div class="form-group row">
                  <label for="BillingDay" class="col-sm-3 col-form-label">
                    Billing Day
                  </label>
                  <div class="col-sm-9" style="width: 42%;">
                    <!-- <p-calendar required [(ngModel)]="model.billingDay" [minDate]="mindate" [maxDate]="maxdate" [readonlyInput]="true" #billingDay="ngModel" id="BillingDay" name="BillingDay" ></p-calendar> -->

                    <mat-form-field class="example-full-width" appearance="outline">
                      <mat-label>Choose a date</mat-label>
                      <input matInput required [(ngModel)]="model.billingDay" #billingDay="ngModel" id="BillingDay" name="BillingDay" [matDatepicker]="picker">
                      <mat-datepicker-toggle matSuffix [for]="picker">
                        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <div *ngIf="billingDay.invalid && (billingDay.dirty && billingDay.touched)" class="text-danger small">
                      <div *ngIf="billingDay.errors.required">
                        BillingDay is required.
                      </div>
                      <div *ngIf="billingDay.errors.maxlength">
                        BillingDay must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="BillingFrequency" class="col-sm-3 col-form-label">
                    Billing Frequency
                  </label>
                  <div class="col-sm-9">
                    <!-- <p-dropdown [options]="frequency" [(ngModel)]="model.billingFrequency" required  #billingFrequency="ngModel" id="BillingFrequency" name="BillingFrequency" [autoWidth]="true" placeholder="Select frequency" [showClear]="true"></p-dropdown> -->
                    <mat-form-field appearance="outline">
                      <mat-label>Select frequency</mat-label>
                      <mat-select [(ngModel)]="model.billingFrequency" required #billingFrequency="ngModel" name="BillingFrequency">
                        <mat-option *ngFor="let freq of frequency" [value]="freq.value">
                          {{freq.label}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div *ngIf="billingFrequency.invalid && (billingFrequency.dirty && billingFrequency.touched)" class="text-danger small">
                      <div *ngIf="billingFrequency.errors.required">
                        BillingFrequency is required.
                      </div>
                      <div *ngIf="billingFrequency.errors.maxlength">
                        BillingFrequency must be less than 50 characters long.
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="APIKey" class="col-sm-3 col-form-label">Client API Key</label>
                  <div class="col-sm-9">
                    <mat-form-field appearance="outline">
                      <mat-label>API Key</mat-label>
                      <input matInput [(ngModel)]="model.apiKey" disabled maxlength="50" #apiKey="ngModel" type="text" id="apiKey" name="apiKey">
                    </mat-form-field>
                  </div>
                </div>

              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="text-center m-3">
                  <!--<button type="button"  (click)="showMappingsModal()" *ngIf="this.isRateFileButtonDisplay == true" class="btn btn-sm btn-info mx-1"> <i class="fa fa-file-excel-o" aria-hidden="true"></i> Map Carrier Rate Files</button>-->
                  <button type="submit" [disabled]="f.invalid" *ngIf="mode==formModes.New" class="btn btn-sm btn-success mx-1"><i class="fa fa-plus" aria-hidden="true"></i> Save </button>
                  <button type="submit" [disabled]="f.invalid" *ngIf="mode==formModes.Edit" class="btn btn-sm btn-primary mx-1" style="color: white; background-color: #2f72ab;"><i class="fa fa-floppy-o" aria-hidden="true"></i> Update </button>
                  <button type="button" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;" (click)="resetForm()"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
                </div>
                <br />
              </div>
            </div>
          </form>
        </div>

        <div *ngIf="mode==formModes.Del">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="Name" class="col-sm-3 col-form-label">Name</label>
                <div class="col-sm-9">
                  <mat-form-field appearance="outline">
                    <mat-label>Enter your name</mat-label>
                    <input matInput [(ngModel)]="model.name" required maxlength="50" #name="ngModel" type="text" id="Name" name="Name" [readonly]="true">
                  </mat-form-field>
                  <div *ngIf="name.invalid && (name.dirty && name.touched)" class="text-danger small">
                    <div *ngIf="name.errors.required">
                      Name is required.
                    </div>
                    <div *ngIf="name.errors.maxlength">
                      Name must be less than 50 characters long.
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="BillingID" class="col-sm-3 col-form-label">Billing ID</label>
                <div class="col-sm-9">
                  <mat-form-field appearance="outline">
                    <mat-label>Billing Id</mat-label>
                    <input matInput [(ngModel)]="model.billingID" required maxlength="50" #billingID="ngModel" type="text" id="BillingID" name="BillingID" [readonly]="true">
                  </mat-form-field>
                  <div *ngIf="billingID.invalid && (billingID.dirty && billingID.touched)" class="text-danger small">
                    <div *ngIf="billingID.errors.required">
                      BillingID is required.
                    </div>
                    <div *ngIf="billingID.errors.maxlength">
                      Billing Id must be less than 50 characters long.
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="BillingContactID" class="col-sm-3 col-form-label">Billing Contact ID</label>
                <div class="col-sm-9">
                  <mat-form-field appearance="outline">
                    <mat-label>Billing Contact ID</mat-label>
                    <input matInput [(ngModel)]="model.billingContactID" required maxlength="50" #billingContactID="ngModel" type="text" id="BillingContactID" name="BillingContactID" [readonly]="true">
                  </mat-form-field>
                  <div *ngIf="billingContactID.invalid && (billingContactID.dirty && billingContactID.touched)" class="text-danger small">
                    <div *ngIf="billingContactID.errors.required">
                      BillingContactID is required.
                    </div>
                    <div *ngIf="billingContactID.errors.maxlength">
                      BillingContactID must be less than 50 characters long.
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-sm-6">
              <div class="form-group row">
                <label for="BillingDay" class="col-sm-3 col-form-label">
                  Billing Day
                </label>
                <div class="col-sm-9" style="width: 42%;">
                  <!-- <p-calendar required [(ngModel)]="model.billingDay" [minDate]="mindate" [maxDate]="maxdate" [readonlyInput]="true" #billingDay="ngModel" id="BillingDay" name="BillingDay" ></p-calendar> -->

                  <mat-form-field class="example-full-width" appearance="outline">
                    <mat-label>Choose a date</mat-label>
                    <input matInput required [(ngModel)]="model.billingDay" #billingDay="ngModel" id="BillingDay" name="BillingDay" [matDatepicker]="picker">
                    <mat-datepicker-toggle matSuffix [for]="picker">
                      <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <div *ngIf="billingDay.invalid && (billingDay.dirty && billingDay.touched)" class="text-danger small">
                    <div *ngIf="billingDay.errors.required">
                      BillingDay is required.
                    </div>
                    <div *ngIf="billingDay.errors.maxlength">
                      BillingDay must be less than 50 characters long.
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="BillingFrequency" class="col-sm-3 col-form-label">
                  Billing Frequency
                </label>
                <div class="col-sm-9">
                  <mat-form-field appearance="outline">
                    <mat-label>Select frequency</mat-label>
                    <mat-select [(ngModel)]="model.billingFrequency" required #billingFrequency="ngModel" name="BillingFrequency" disabled>
                      <mat-option *ngFor="let freq of frequency" [value]="freq.value" disabled>
                        {{freq.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="billingFrequency.invalid && (billingFrequency.dirty && billingFrequency.touched)" class="text-danger small">
                    <div *ngIf="billingFrequency.errors.required">
                      BillingFrequency is required.
                    </div>
                    <div *ngIf="billingFrequency.errors.maxlength">
                      BillingFrequency must be less than 50 characters long.
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="text-center m-3">
                <button type="button" (click)="onSubmit()" class="btn btn-sm btn-danger mx-1"><i class="fa fa-times" aria-hidden="true"></i> Delete </button>
                <button type="button" (click)="resetForm()" class="btn btn-sm btn-outline-secondary mx-1" style="color: white; background-color: #2f72ab;"><i class="fa fa-ban" aria-hidden="true"></i> Cancel </button>
              </div>
              <br />
            </div>
          </div>
        </div>

      </div>
    </div>

    <div *ngIf="mode != formModes.New && mode != formModes.Edit" class="row">
      <div class="col">

        <div class="mat-elevation-z8">
          <table mat-table [dataSource]="ClientdataSource">

            <!-- <ng-container matColumnDef="Id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Id </th>
              <td mat-cell *matCellDef="let row">{{ row.Id }}  </td>
            </ng-container> -->

            <ng-container matColumnDef="Name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
              <td mat-cell *matCellDef="let row"> {{ row.name }} </td>
            </ng-container>

            <ng-container matColumnDef="BillingID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> BillingID </th>
              <td mat-cell *matCellDef="let row"> {{ row.billingID }} </td>
            </ng-container>

            <ng-container matColumnDef="BillingContactID">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> BillingContactID </th>
              <td mat-cell *matCellDef="let row">{{ row.billingContactID }}  </td>
            </ng-container>
            <ng-container matColumnDef="BillingDay">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> BillingDay </th>
              <td mat-cell *matCellDef="let row"> {{ row.billingDay | date:'shortDate'}} </td>
            </ng-container>
            <ng-container matColumnDef="BillingFrequency">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> BillingFrequency </th>
              <td mat-cell *matCellDef="let row"> {{ frequency | getLabelOf : row.billingFrequency }} </td>
            </ng-container>
            <ng-container matColumnDef="LastBilled">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> LastBilled </th>
              <td mat-cell *matCellDef="let row">   {{ row.lastBilled | date:'shortDate' }}         </td>
            </ng-container>
            <ng-container matColumnDef="...">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ... </th>
              <td mat-cell *matCellDef="let row">
                <button (click)="showEdit(row)" class="btn btn-sm btn-outline-primary"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                <button (click)="showDel(row)" class="btn btn-sm btn-outline-danger"><i class="fa fa-times" aria-hidden="true"></i></button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


          </table>
          <!--<tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">There is no record</td>
          </tr>-->
          <span style="position: relative;
            left: 47%;
            top: 36px;">There are {{this.tabledata?.length}} records</span>
          <mat-paginator #paginator [length]="this.tabledata?.length" [pageSizeOptions]="[10, 25, 100]" aria-label="Select page of Client Master" (page)="onChangedPageSize($event)"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
